/** The stable session-storage key prefix for retained Ask conversations. */
export const ASK_TURNS_STORAGE_KEY_PREFIX = 'ask-helix-turns-v1';
